<template>
  <div>
    <div class="row">
      <div class="col-8">
        <form>
          <div v-for="phoenix_setting in filtered_phoenix_settings" :key="phoenix_setting.phoenix_setting_id">
            <div class="form-group row" v-if="phoenix_setting.setting === 'RTP_IP'">
              <label for="txtRtpIpValue" class="col-2 col-form-label">RTP IP</label>
              <div class="col-10">
                <input type="text" class="form-control" id="txtRtpIpValue"
                       v-model="phoenix_setting.value">
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SIP_IP'">
              <label for="txtSipIpValue" class="col-2 col-form-label">SIP IP</label>
              <div class="col-10">
                <input type="text" class="form-control" id="txtSipIpValue"
                       v-model="phoenix_setting.value">
              </div>
            </div>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()" v-if="[3].includes(logged_in_user.group_id)">Save</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      phoenix_settings: 'allPhoenixSettings',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_phoenix_settings: function () {
      return this.phoenix_settings.filter(ps => ps.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.INTERCOM.SIP_PROFILES.EXTERNAL')
  },
  methods: {
    submit () {
      this.$store.dispatch('editPhoenixSettings', this.phoenix_settings)
    }
  }
}
</script>

<style scoped>

</style>
